import dayjs from 'dayjs';
import Lottie from 'lottie-react';
import {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import sanitize from 'sanitize-html';
import styled from 'styled-components';
import {useRefetchMe} from '@/api/session';
import {Button} from '@/components/Button';
import {CheckLottie, ConfettiLottie} from '@/components/Lottie';
import {Typography} from '@/components/Typography';
import {FULL_DATE_FORMAT, TRIAL_DURATION} from '@/constants';
import {PaymentActionType, ProductTier} from '@/enums';
import {useSession} from '@/hooks';
import {PaymentProcessParams} from '@/interface';
import {paths} from '@/router';
import {FlexFullGrow, PageContent} from '@/styled-components';
import {MEDIA_QUERIES, palette} from '@/styles';

export const Success = ({type}: PaymentProcessParams) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isTrial = searchParams.get('tier') === ProductTier.Trial;
  const {user} = useSession();

  const title =
    type === PaymentActionType.method
      ? '카드 정보가<br/>정상적으로 변경되었습니다.'
      : isTrial
      ? `${TRIAL_DURATION}일 무료체험이 시작되었습니다`
      : '정상적으로 결제되었습니다';
  const desc =
    type !== PaymentActionType.method &&
    (isTrial
      ? user?.trialInfo?.length &&
        user.trialInfo[user.trialInfo.length - 1].useEndedAt
        ? `${dayjs(user.trialInfo[user.trialInfo.length - 1].useEndedAt).format(
            FULL_DATE_FORMAT
          )}에 구독이 시작됩니다.`
        : ''
      : '마이프차 지도 서비스를 이용해주셔서 고맙습니다.');

  const refetchMe = useRefetchMe();

  const onClick = () => {
    const pathname =
      type === PaymentActionType.method ? paths.mypage_pay : paths.map_root;
    navigate({pathname});
  };

  useEffect(() => {
    refetchMe();
  }, [refetchMe]);

  return (
    <Root>
      <Typography
        variant="bold24"
        color={palette.gray900}
        align="center"
        dangerouslySetInnerHTML={{
          __html: sanitize(title),
        }}
      />
      {!!desc && (
        <Typography variant="medium14" color={palette.gray600}>
          {desc}
        </Typography>
      )}
      <ImageWrapper>
        <Lottie
          loop={isTrial ? true : false}
          animationData={isTrial ? ConfettiLottie : CheckLottie}
          style={{width: 140, height: 140}}
        />
      </ImageWrapper>
      <Button
        size="mediumLarge"
        color="primary"
        variant="fill"
        fullWidth
        onClick={onClick}
      >
        {type === PaymentActionType.method ? '확인' : '마이프차 지도 시작하기'}
      </Button>
    </Root>
  );
};

const Root = styled(PageContent)`
  align-items: center;
  ${MEDIA_QUERIES.exclude_mobile} {
    min-height: 482px;
  }
  min-height: 100%;
  gap: 16px;
`;

const ImageWrapper = styled(FlexFullGrow)`
  display: flex;
  align-items: center;
`;
